import { Overlay, OverlayContainer } from "@angular/cdk/overlay";
import { DatePipe } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
// import { AngularFireModule } from "@angular/fire";
// import { AngularFireAuthModule } from "@angular/fire/auth";
// import { AngularFirestoreModule } from "@angular/fire/firestore";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MAT_MENU_SCROLL_STRATEGY } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BackButtonDisableModule } from "angular-disable-browser-back-button";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxSpinnerModule } from "ngx-spinner";
import { environment } from "../environments/environment";
import { EcollectRemitterComponent } from "./admin/components/ecollect-remitter/ecollect-remitter.component";
import { NgbDateFRParserFormatter } from "./admin/helpers/ngb-date-fr-parser-formatter.helper";
import { admin_service } from "./admin/services/admin.service";
import { EncrDecrService } from "./admin/services/encr-decr-service.service";
import { fund_service } from "./admin/services/fund.service";
import { server } from "./admin/services/global.service";
import { organisation_service } from "./admin/services/organisation.service";
import { staff_service } from "./admin/services/staff.service";
import { user_service } from "./admin/services/user.service";
import { AppComponent } from "./app.component";
import { routing } from "./app.routing";
import { AppService } from "./app.service";
import { AppSettings } from "./app.settings";
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { AppInterceptor } from "./theme/utils/app-interceptor";
import { CustomOverlayContainer } from "./theme/utils/custom-overlay-container";
import { menuScrollStrategy } from "./theme/utils/scroll-strategy";
// import { YesbankconsolenavbarComponent } from "./yesbankconsolenavbar/yesbankconsolenavbar.component";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { CustomValidator } from "./theme/utils/custom.validator";
import { PPAVkycComponent } from './components/ppa-vkyc/ppa-vkyc.component';
import {MatCardModule} from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatGridListModule} from '@angular/material/grid-list';
@NgModule({
  imports: [
    BrowserModule,
    MatInputModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxSpinnerModule,
    MatProgressSpinnerModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    routing,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatGridListModule,
    // AngularFireModule.initializeApp(environment.firebase),
    // AngularFirestoreModule, // imports firebase/firestore, only needed for database features
    // AngularFireAuthModule, // imports firebase/auth, only needed for auth features
    BackButtonDisableModule.forRoot({ preserveScrollPosition: true }),
    NgxDaterangepickerMd.forRoot(),
    NgbModule
  ],
  declarations: [
    AppComponent,
    // YesbankconsolenavbarComponent,
    ResetPasswordComponent,
    PPAVkycComponent
  ],
  providers: [
    AppSettings,
    AppService,
    user_service,
    server,
    fund_service,
    organisation_service,
    EncrDecrService,
    admin_service,
    staff_service,
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    { provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter },
    DatePipe,
    {
      provide: MAT_MENU_SCROLL_STRATEGY,
      useFactory: menuScrollStrategy,
      deps: [Overlay],
    },
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    { provide: CustomValidator, useClass:  CustomValidator, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
